import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}
    :host {
        overflow-x: auto;
    }

    .container {
        width: 100%;
        display: flex;
        flex-direction: row;
        position: relative;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    .container::-webkit-scrollbar {
        display: none;
    }

    .list {
        display: flex;
        gap: var(--sgdf-spacing-medium);
        overflow-x: scroll;
        width: 100%;
    }

    .small {
        padding-left: 50px;
        padding-right: 50px;
    }

    .left-div {
        position: absolute;
        width: 50px;
        height: 100%;
        background: linear-gradient(to right, white, transparent);
        z-index: 1;
    }
    .right-div {
        position: absolute;
        width: 50px;
        height: 100%;
        z-index: 1;
        background: linear-gradient(to left, white, transparent);
        right: 0;
    }
`;
//# sourceMappingURL=day-selector.styles.js.map